import { useState } from 'react'
import { texts } from '@/texts'

interface ProfileSetupProps {
  onProfileCreated: (name: string, dateOfBirth: string) => void
}

export function ProfileSetup({ onProfileCreated }: ProfileSetupProps) {
  const [name, setName] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!name.trim() || !dateOfBirth) return

    setIsSubmitting(true)
    setTimeout(() => {
      onProfileCreated(name, dateOfBirth)
      setIsSubmitting(false)
    }, 300)
  }

  const isValid = name.trim() && dateOfBirth && !isSubmitting

  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-4)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingTop: 'var(--spacing-8)',
    }}>
      <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-8)' }}>
        <div className="mg-brand" style={{ fontSize: '3.2rem' }}>
          Zahlio<span className="mg-brand-heart">{'♥︎'}</span>
        </div>
        <p className="mg-brand-sub" style={{ fontSize: '1rem', margin: '4px 0 var(--spacing-4) 0' }}>
          {texts.app.brandSubtitle}
        </p>
        <p style={{
          fontFamily: 'var(--font-serif)',
          fontSize: '1.05rem',
          color: 'var(--mg-text-muted)',
          lineHeight: '1.55',
        }}>
          {texts.profileSetup.introLine1}<br />
          {texts.profileSetup.introLine2}
        </p>
      </div>

      <div style={{ maxWidth: '400px', margin: '0 auto', width: '100%' }}>
        <div className="mg-card" style={{ padding: 'var(--spacing-6)' }}>
          <h2 style={{
            fontFamily: 'var(--font-serif)',
            fontSize: '1.5rem',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--mg-gold-soft)',
            marginBottom: 'var(--spacing-6)',
            textAlign: 'center',
            textShadow: '0 0 14px rgba(232, 200, 122, 0.35)',
          }}>
            {texts.profileSetup.formTitle}
          </h2>

          <div style={{ marginBottom: 'var(--spacing-5)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'var(--spacing-2)',
              fontWeight: 'var(--font-weight-semibold)',
              fontSize: '0.95rem',
              color: 'var(--mg-text)',
            }}>
              {texts.profileSetup.nameLabel}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={texts.profileSetup.namePlaceholder}
              disabled={isSubmitting}
              style={{ width: '100%', opacity: isSubmitting ? 0.6 : 1 }}
            />
          </div>

          <div style={{ marginBottom: 'var(--spacing-6)' }}>
            <label style={{
              display: 'block',
              marginBottom: 'var(--spacing-2)',
              fontWeight: 'var(--font-weight-semibold)',
              fontSize: '0.95rem',
              color: 'var(--mg-text)',
            }}>
              {texts.profileSetup.dateLabel}
            </label>
            <input
              type="date"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              disabled={isSubmitting}
              style={{ width: '100%', opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
            />
          </div>

          <button className="mg-btn-primary" onClick={handleSubmit} disabled={!isValid}>
            {isSubmitting ? texts.profileSetup.submittingButton : texts.profileSetup.submitButton}
          </button>

          <p style={{
            fontSize: '0.75rem',
            color: 'var(--mg-text-dim)',
            textAlign: 'center',
            margin: 'var(--spacing-4) 0 0 0',
          }}>
            {texts.profileSetup.storageHint}
          </p>
        </div>
      </div>

      <div style={{ marginTop: 'auto', paddingTop: 'var(--spacing-8)', paddingBottom: 'var(--spacing-4)', textAlign: 'center' }}>
        <p style={{ fontSize: '0.75rem', color: 'var(--mg-text-dim)', margin: 0 }}>
          {texts.profileSetup.footerHint}
        </p>
      </div>
    </div>
  )
}
